import { Breadcrumb } from "antd";
import React from "react"
import { useState } from "react"
import SelectCustomer from "./SelectCustomer";
import SelectContact from "./SelectContact";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";


export const  SearchCustomer = ({returnData, showModal, onClose, customerList, customerColumns}) => {
    const [step, setStep] = useState(1);
    const [objCustomer, setObjCustomer] = useState({});
    const [objContact, setObjContact] = useState({});
    const [customerID, setCustomerID] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [contactID, setContactID] = useState(0);
    const [contactName, setContactName] = useState(0);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    const handleCustomerSelection = async(obj, nextStep) => {
        
        //Show status warning
        if(obj.Status !== 'Regular' && obj.Status !== 'Monitored') {// (obj.Status !== 'Authorized to deal') {
            nextStep = 1;
            setAlertMessage('Customer is in ' + obj.Status + ' status. Deals cannot be created or edited under this customer.');
            setAlertTitle('Warning');
            setShowAlert(true);
        }
        else
        {
            setObjCustomer(obj);
            setCustomerID(obj['Customer ID']);
            setCustomerName(obj['Customer Name']);
            
            if (nextStep === 2) {                
                setStep(nextStep);
            }
    }
    }

    const handleContactSelection = (obj) => {
        setStep(3);
        setObjContact(obj);
        setContactID(obj['Contact ID']);
        setContactName(obj['Name']);
        returnData(`${customerName} ${obj['Name']}`)
    }

    const contacts_length = (n) =>{
        if(n===0){
            setStep(1);
            setAlertTitle('Message');
            setAlertMessage('There are no active customer contacts for this customer.');
        }
    }

    const getBreadcrumb = () =>{
            let breadcrumb = [];
             switch (step) {
                        case 1:
                        default:
                            breadcrumb.push(<Breadcrumb.Item key="bd-order" className="breadcrumb-item-bold" onClick={() => setStep(1)}>{`Buscar cliente`}</Breadcrumb.Item>)   
                            break;
                        case 2:
                            breadcrumb.push(
                                            <Breadcrumb.Item key="bd-order" className="breadcrumb-item" onClick={() => setStep(1)}>{`Buscar cliente`}</Breadcrumb.Item>
                                        );
                            breadcrumb.push(
                                            <Breadcrumb.Item key="bd-order-cust" className="breadcrumb-item-bold" onClick={() => setStep(2)}>{objCustomer["Customer Name"]} - Contacto</Breadcrumb.Item>
                                        );
                            break;
                        }
            return breadcrumb;
        }

    const getStepScreen = () =>{
            let screen = <></>;
             switch (step) {
                        case 1:
                        default:
                            screen = (<SelectCustomer id="comp_customer_form"
                                onCustomerSelected={handleCustomerSelection}
                                customerListTotal={customerList} customerColumns={customerColumns}/>);         
                            break;
                        case 2:
                            screen = (<SelectContact id="comp_contact_form"
                                            onContactSelected={handleContactSelection}
                                            contacts_length={contacts_length}
                                            objCustomer={objCustomer} />);
                            break;
                        }
            return screen;
        }
    

    return <>
                <Dialog open={showModal} maxWidth='md' fullWidth={true} onClose={onClose} >
                    <DialogContent>
                        <div className="breadcrumb-div">
                            <Breadcrumb separator=">">
                                {getBreadcrumb()}
                            </Breadcrumb>
                        </div>
                        {getStepScreen()}              
                    </DialogContent>
                    <DialogActions>
                        <button className="uk-button uk-button-green" key={"cancel"} type="button" onClick={onClose}>Close</button>
                    </DialogActions>
                </Dialog>
                
    
        </>

}